<!--平台伙伴-->
<template>
  <div>
    <el-row>
      <el-col :span="4">
        <div class="grid-content"></div>
      </el-col>
      <!--面包屑-->
      <el-col :span="16">
        <div class="grid-content">
          <el-breadcrumb class='crumbs' separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">平台伙伴</a></el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content"></div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4">
        <div class="grid-content1"></div>
      </el-col>
      <el-col :span="16">
        <!-- tabs选项卡-->
        <div class="grid-content1">
          <el-tabs :tab-position="tabPosition" v-model='activeName' @tab-click="jump">
            <el-tab-pane :label="item.name" :name="item.stringId" v-for="item in tableListData" :key="item.stringId" :data-item="JSON.stringify(item)">
              <el-tabs type="border-card">
                <el-tab-pane :label="blurbName" v-if="blurb">
                  <div class='text'>
                    <p v-html='blurbDetailed.content'></p>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="meetingName" v-if="meeting">
                  <ul v-for="item1 in meetingList" :key="item1.stringId" @click="details(item1)">
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>{{ item1.title }}</a>
                        </li>
                        <li class='date'>
                          <span>{{ item1.creteNewTime }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination class="pagination"
                                 v-show="meetingTotal>0"
                                 :total="meetingTotal"
                                 :current-page.sync="queryNewsParams.pageNum"
                                 :page-size.sync="queryNewsParams.pageSize"
                                 @current-change="getHomeResearchNews"
                  >
                  </el-pagination>

                </el-tab-pane>
                <el-tab-pane :label="challengeName" v-if="challenge">
                  <ul v-for="item1 in challengeList" :key="item1.stringId" @click="details(item1)">
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>{{ item1.title }}</a>
                        </li>
                        <li class='date'>
                          <span>{{ item1.creteNewTime }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination class="pagination"
                                 v-show="challengeTotal>0"
                                 :total="challengeTotal"
                                 :current-page.sync="challengeParams.pageNum"
                                 :page-size.sync="challengeParams.pageSize"
                                 @current-change="getChallenge"
                  >
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane :label="productName" v-if="product">
                  <ul v-for="item1 in productList" :key="item1.stringId" @click="details(item1)">
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>{{ item1.title }}</a>
                        </li>
                        <li class='date'>
                          <span>{{ item1.creteNewTime }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination class="pagination"
                                 v-show="productTotal>0"
                                 :total="productTotal"
                                 :current-page.sync="productParams.pageNum"
                                 :page-size.sync="productParams.pageSize"
                                 @current-change="getProduct"
                  >
                  </el-pagination>
                </el-tab-pane>


                <el-tab-pane :label="informationName" v-if="information">
                  <ul v-for="item1 in informationList" :key="item1.stringId" @click="details(item1)">
                    <li class='content'>
                      <ul>
                        <li class='icon'>
                          <i class="el-icon-document"></i>
                        </li>
                        <li class='title'>
                          <a>{{ item1.title }}</a>
                        </li>
                        <li class='date'>
                          <span>{{ item1.creteNewTime }}</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!--分页-->
                  <el-pagination class="pagination"
                                 v-show="informationTotal>0"
                                 :total="informationTotal"
                                 :current-page.sync="informationParams.pageNum"
                                 :page-size.sync="informationParams.pageSize"
                                 @current-change="getInformation"
                  >
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content1"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {headlineNewsList, homePartnerNews, homeResearchNews, homeWholePartner, appointPartner} from "@api/auth";
import {collect} from "echarts/lib/component/axisPointer/modelHelper";

export default {
  activated() {
    this.getList();
  },
  data() {
    return {
      fits: ['cover'],
      tabPosition: 'left',
      tableListData: [],
      newsListData: [],
      partnerTypes: [],
      blurb: false,
      meeting: false,
      information: false,
      product: false,
      blurbName: '简介',
      meetingName: '会议',
      challengeName: '挑战赛',
      productName: '业务产品',
      informationName: '资讯',

      challenge: false,
      blurbDetailed: {},
      meetingList: [],
      challengeList: [],
      informationList: [],
      productList: [],

      activeName: 'tab1',
      typeDetailed: 'tab1',
      subtitle: '',
      queryParams: {
        type: '4',

      },
      // 总条数
      meetingTotal: 0,
      challengeTotal: 0,
      informationTotal: 0,
      productTotal: 0,

      queryNewsParams: {
        pageNum: 1,
        pageSize: 10,
        type: '4',
        typeName: '会议',
        category: '1'
      },
      productParams: {
        pageNum: 1,
        pageSize: 10,
        type: '4',
        typeName: '业务产品',
        category: '1'
      },
      challengeParams: {
        pageNum: 1,
        pageSize: 10,
        type: '4',
        typeName: '挑战赛',
        category: '1'
      },
      informationParams: {
        pageNum: 1,
        pageSize: 10,//每页几条
        type: '4',
        typeName: '资讯',
        category: '1'
      }
    }
  },
  methods: {
    jump(tab, event) {
      this.queryParams.type = tab.name;
      let that = this;
      that.blurb = false;
      that.meeting = false;
      that.information = false;
      that.challenge = false;
      that.product = false;
      appointPartner(this.queryParams).then(res => {

        if (res.data.partnerTypes.length==0) {
          window.open(JSON.parse(tab.$el.dataset.item).code, '_blank')
        } else {
          that.partnerTypes = res.data.partnerTypes;
          that.partnerTypes.forEach((value, index) => {
            if (value.name == '简介' || value.name == 'Introduction') {
              that.blurb = true;
              if (!res.data.blurb && typeof (res.data.blurb) != "undefined" && res.data.blurb != 0) {
              } else {
                that.blurbDetailed = res.data.blurb;
              }
              that.blurbName = value.name;
            } else if (value.name == '会议' || value.name == 'Activities') {
              that.meeting = true;
              that.queryNewsParams.typeName = value.name;
              if (!res.data.meetingList && typeof (res.data.meetingList) != "undefined" && res.data.meetingList != 0) {
              } else {
                that.meetingList = res.data.meetingList.records;
                that.meetingTotal = res.data.meetingList.total;
              }
              that.meetingName = value.name;
            } else if (value.name == '资讯' || value.name == 'Courses') {
              that.information = true
              that.informationParams.typeName = value.name;
              if (!res.data.informationList && typeof (res.data.informationList) != "undefined" && res.data.informationList != 0) {
              } else {
                that.informationList = res.data.informationList.records;
                that.informationTotal = res.data.informationList.total;
              }
              that.informationName = value.name;
            } else if (value.name == '挑战赛' || value.name == 'Information') {
              that.challenge = true
              that.challengeParams.typeName = value.name;
              if (!res.data.challengeList && typeof (res.data.challengeList) != "undefined" && res.data.challengeList != 0) {
              }else{
                that.challengeList = res.data.challengeList.records;
                that.challengeTotal = res.data.challengeList.total;
              }
              that.challengeName = value.name;
            } else if (value.name == '业务产品') {
              that.product = true
              if (!res.data.productsList && typeof (res.data.productsList) != "undefined" && res.data.productsList != 0) {
              }else{
                that.productList = res.data.productsList.records;
                that.productTotal = res.data.productsList.total;
              }
              that.productName = value.name;
            }
          });        }

      })
    },
    details(raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
        },
      })
    },
    getHomeResearchNews() {
      let that = this;
      that.queryNewsParams.type = that.activeName;
      homePartnerNews(this.queryNewsParams).then(res => {
        that.meetingTotal = res.data.total;
        that.meetingList = res.data.records;
      })
    },
    getChallenge() {
      let that = this;
      that.challengeParams.type = that.activeName;
      homePartnerNews(this.challengeParams).then(res => {
        that.challengeTotal = res.data.total;
        that.challengeList = res.data.records;
      })
    },
    getProduct() {
      let that = this;
      that.productParams.type = that.activeName;
      homePartnerNews(this.productParams).then(res => {
        that.productTotal = res.data.total;
        that.productList = res.data.records;
      })
    },

    getInformation() {
      let that = this;
      that.informationParams.type = that.activeName;
      homePartnerNews(this.informationParams).then(res => {
        that.informationTotal = res.data.total;
        that.informationList = res.data.records;
      })
    },
    getList() {
      let that = this;
      homeWholePartner(this.queryParams).then(res => {
        that.tableListData = res.data.categories;
        that.partnerTypes = res.data.partnerTypes;
        that.partnerTypes.forEach((value, index) => {
          if (value.name == '简介' || value.name == 'Introduction') {
            that.blurb = true;
            if (!res.data.blurb && typeof (res.data.blurb) != "undefined" && res.data.blurb != 0) {
            } else {
              that.blurbDetailed = res.data.blurb;
            }
            that.blurbName = value.name;
          } else if (value.name == '会议' || value.name == 'Activities') {
            that.meeting = true;
            that.queryNewsParams.typeName = value.name;
            if (!res.data.meetingList && typeof (res.data.meetingList) != "undefined" && res.data.meetingList != 0) {
            } else {
              that.meetingList = res.data.meetingList.records;
              that.meetingTotal = res.data.meetingList.total;
            }
            that.meetingName = value.name;
          } else if (value.name == '资讯' || value.name == 'Courses') {
            that.information = true;
            that.informationParams.typeName = value.name;
            that.informationName = value.name;
            if (!res.data.informationList && typeof (res.data.informationList) != "undefined" && res.data.informationList != 0) {
            } else {
              that.informationList = res.data.informationList.records;
              that.informationTotal = res.data.informationList.total;
            }
          } else if (value.name == '挑战赛' || value.name == 'Information') {
            that.challenge = true;
            that.challengeParams.typeName = value.name;
            that.challengeName = value.name;
            if (!res.data.challengeList && typeof (res.data.challengeList) != "undefined" && res.data.challengeList != 0) {

            } else {
              that.challengeList = res.data.challengeList.records;
              that.challengeTotal = res.data.challengeList.total;
            }
          } else if (value.name == '业务产品') {
            that.product = true
            that.productName = value.name;
            if (!res.data.productsList && typeof (res.data.productsList) != "undefined" && res.data.productsList != 0) {

            } else {
              that.productList = res.data.productsList.records;
              that.productTotal = res.data.productsList.total;
            }
          }
        });
        that.activeName = that.tableListData[0].stringId;
      })
    },
  }
}
</script>

<style lang="less" scoped>
.el-row {
  padding-bottom: 20px;
  background-color: #eee;

  &:last-child {
    margin-bottom: 0;
  }
}

.grid-content {
  height: 50px;
  //面包屑
  .crumbs {
    line-height: 50px;
    font-size: 16px;
    text-indent: 10px;
    background-color: #fff;
    margin-top: 20px;
  }
}

::v-deep .el-tabs__content {
  padding-bottom: 20px;
  background-color: #fff;
}

.grid-content1 {
  min-height: 100px;
  //文本内容
  .text {
    p {
      line-height: 28px;
      font-size: 14px;
      font-family: " 黑体";
    }

    h2 {
      line-height: 28px;
      font-size: 15px;
      font-family: " 黑体";
      font-weight: bold;
      color: #666;
    }
  }

  .content {
    height: 50px;
    padding: 0 15px;
    background-color: #fff;
    border-bottom: 1px dashed #999;
    line-height: 50px;

    .icon {
      width: 2.5%;
      float: left;
    }

    .title {
      width: 85%;
      float: left;

      a {
        width: 100%;
        display: block;
        color: #666;
        font-family: " 黑体";
        overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
        text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
        white-space: nowrap; /*文本不换行*/
      }

      a:hover {
        color: #409EFF;
      }
    }

    .date {
      width: 12.5%;
      float: right;
      text-align: right;
    }
  }

  .paging {
    width: 100%;
    height: 80px;
    background-color: #fff;

    .pagination {
      float: right;
      margin-top: 20px;
    }
  }
}

.pagination {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 50px;
}

//tabs选项卡
::v-deep .el-tabs {
  background-color: #fff;
}

::v-deep .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
  height: 46px;
  width: 300px;
  font-family: Tahoma;
  font-size: 14px;
  color: #333;
}

::v-deep .el-tabs__nav-scroll {
  background-color: #fff !important;
}

::v-deep .el-tabs--left .el-tabs__item.is-left:hover {
  background-color: #6aa84f;
  color: #fff;
}

::v-deep .el-tabs--left .el-tabs__item.is-left:nth-child(1) :hover {
  color: #409EFF;
}

::v-deep .el-tabs--left .el-tabs__item.is-left:focus {
  background-color: #6aa84f;
  color: #fff;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-size: 16px;
  font-weight: bold;
  font-family: " 黑体";
  width: 245px;
  color: #666;
  text-align: center;
  border: 0;
}

::v-deep .el-tabs--left .el-tabs__header.is-left {
  margin: 0;
}

// 默认选中的样式
::v-deep .el-tabs--left .el-tabs__item.is-active {
  background-color: #6aa84f;
  color: #fff;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #fff;
  color: #409EFF;
}
</style>
